import React, { Component } from 'react'
import { connect } from 'react-redux'

class ModalSearch extends Component {
  render () {
    if (!this.props.filter) return null
    return (
      <div className={(this.props.filter ? 'modal-search-wrapper' : 'hidden') + ' hidden-xs'}>
        <div className='form-group modal-search-form-group'>
          <i className='fa fa-search' />
          <input
            autoFocus
            type='text'
            className='form-control'
            id='modal-search-input'
            onChange={e => this.props.filter(e)}
            onKeyUp={e => this.props.filter(e)} />
        </div>
      </div>
    )
  }
}
// eslint-disable-next-line
ModalSearch = connect(state => state)(ModalSearch)
export default ModalSearch



// WEBPACK FOOTER //
// ./src/components/basic/containers/ModalSearch.js